import { Fragment, useState, useEffect, useMemo } from 'react';
import '../styles.scss';
import { SettingOutlined, EyeOutlined, CloseOutlined } from '@ant-design/icons';
import { Modal, Button, Table } from 'antd';
import MegaTable from '../../../components/MagaTableV2';
import { mixGetV2 } from '../../../services/mixin'
import { useSelector } from 'react-redux';
import { selectorInfoUser } from '../../../store/slices/infoUserSlice';

const TabTableDetail = ({ stData = {} as any, stChange = (data: any, type: any) => { } }) => {
  const user = useSelector(selectorInfoUser);
  const [surveyModalOpen, setSurveyModalOpen] = useState(false);

  const tableColumns = (sourceColumnWarehouse: any) => {
    const temp = [] as any
    sourceColumnWarehouse.survey_detail?.list.map((col: any) => {
      temp.push({
        headerName: col.headerName,
        field: col.field,
        tooltipField: col.field,
      })
    })
    return temp
  }
  const [megaTableData, setMegaTableData] = useState<any>({
    name: 'TbCacheSurveyInformationDetail',
    col: [
      ...tableColumns(stData.sourceColumnWarehouse),
      {
        headerName: 'Khảo sát',
        field: 'survey_action',
        width: 110,
        resizable: false,
        sortable: false,
        filter: false,
        lockPosition: 'right',
        cellRenderer: (params: any) => {
          if (!params.data) return null;
          return (
            <div className='d-flex gap-4 justify-start align-center h-full'>
              <EyeOutlined
                className='cursor-pointer'
                onClick={() => setSurveyModalOpen(true)}
              />
            </div>
          )
        },
      },
      // { headerName: 'Số khung (VIN)', field: 'chassis_no' },
      // { headerName: 'Biển số xe', field: 'number_plate' },
      // { headerName: 'Số máy', field: 'Số máy' },
      // { headerName: 'Màu xe', field: 'Màu xe' },
      // { headerName: 'Loại động cơ', field: 'Loại động cơ' },
      // { headerName: 'Ngày mua xe', field: 'Ngày mua xe' },
      // { headerName: 'Ngày ký HĐ', field: 'Ngày ký HĐ' },
      // { headerName: 'Số HĐ', field: 'Số HĐ' },
      // { headerName: 'Ngày giao xe', field: 'Ngày giao xe' },
      // { headerName: 'Số Km hiện tại', field: 'present_mile_age' },
      // { headerName: 'Số LSC', field: 'Số LSC' },
      // { headerName: 'Đã nhắc BD 1000km', field: 'Đã nhắc BD 1000km' },
      // { headerName: 'Ngày nhắc BD', field: 'Ngày nhắc BD' },
      // { headerName: 'Đã vào bảo dưỡng 1000km', field: 'Đã vào bảo dưỡng 1000km' },
      // { headerName: 'Câu hỏi khảo sát', field: 'Câu hỏi khảo sát' },
    ],
    listData: [],
    selectedRowKeys: [],
    hideRowsSelect: true,
    showSetting: false,
    loading: false,
  });

  const [loading, setLoading] = useState(false);
  const getDetail = async (id: any) => {
    setLoading(true);
    const res = await mixGetV2(`/api/v1/be/customer/survey?id_survey=${id}&admin_id=${user.id}`);
    if (res.data) {
      stChange({ ...stData, thongtinkhaosat_show_detail: res.data }, 'detailSurveyInformation');
      setLoading(false);
    }
  }
  useEffect(() => {
    if (stData.thongtinkhaosat_show && stData.thongtinkhaosat_show.id) {
      getDetail(stData.thongtinkhaosat_show.id);
    }
  }, [stData.thongtinkhaosat_show]);

  const surveyQuestions = useMemo(() => {
    const question = stData.thongtinkhaosat_show_detail?.question;
    if (!question || typeof question !== 'object') return [];
    const mapAnswer = (val: any) => {
      const s = String(val ?? '').trim();
      if (s === '1') return 'Có';
      if (s === '0') return 'Không';
      if (s === '-1' || s === '') return 'Không xác định';
      return s;
    };
    return Object.values(question).map((q: any, idx: number) => ({
      key: q?.code || idx,
      stt: idx + 1,
      question_text: q?.question_text || '',
      answer: mapAnswer(q?.answer),
      reasons: q?.reasons && String(q.reasons).trim() ? q.reasons : 'Không xác định',
    }));
  }, [stData.thongtinkhaosat_show_detail]);

  const surveyColumns = [
    { title: 'STT', dataIndex: 'stt', key: 'stt', width: 60, sorter: (a: any, b: any) => a.stt - b.stt },
    { title: 'Câu hỏi khảo sát', dataIndex: 'question_text', key: 'question_text', sorter: (a: any, b: any) => String(a.question_text).localeCompare(String(b.question_text)) },
    { title: 'Câu trả lời', dataIndex: 'answer', key: 'answer', width: 150, sorter: (a: any, b: any) => String(a.answer).localeCompare(String(b.answer)) },
    { title: 'Lý do (nếu có)', dataIndex: 'reasons', key: 'reasons', width: 250, sorter: (a: any, b: any) => String(a.reasons).localeCompare(String(b.reasons)) },
  ];

  return (
    <Fragment>
      <div className="custom-page-css w-full flex flex-col items-center justify-between  pt-3">
        <div className="w-full flex items-center justify-end">

          <div className="custom-page-css absolute -top-60-px z-10 flex items-center justify-end gap-3 ">
            <div className="custom-page-css h-8 w-8 flex items-center justify-center rounded border cursor-pointer"
              onClick={() => setMegaTableData((prev: any) => ({ ...prev, showSetting: true }))}
            >
              <SettingOutlined />
            </div>

          </div>
        </div>
        <div className={` w-full`}>
          <MegaTable
            stData={{ ...megaTableData, listData: stData.thongtinkhaosat_show_detail ? [stData.thongtinkhaosat_show_detail] : [], loading: loading }}
            stChange={(data = {}, type = '') => {
              setMegaTableData((prev: any) => ({ ...prev, ...data }));
            }}
          />
        </div>
      </div>

      <Modal
        open={surveyModalOpen}
        onCancel={() => setSurveyModalOpen(false)}
        centered
        width={900}
        destroyOnClose
        closeIcon={false}
        className='rs-modal'
        title={
          <div className='d-flex justify-betweeen align-center w-full'>
            <span className='text-base font-medium'>Xem chi tiết câu hỏi khảo sát</span>
            <CloseOutlined className='cursor-pointer' onClick={() => setSurveyModalOpen(false)} />
          </div>
        }
        footer={
          <div className='custom-page-css w-full flex justify-end'>
            <Button type='primary' onClick={() => setSurveyModalOpen(false)}>Đóng</Button>
          </div>
        }
      >
        <Table
          rowKey='key'
          columns={surveyColumns}
          dataSource={surveyQuestions}
          pagination={false}
          scroll={{ y: 420 }}
          size='middle'
        />
      </Modal>
    </Fragment>
  )

}

export default TabTableDetail
